import React from 'react'
import { Link } from 'gatsby'

import tiktok from '../img/social/tiktok-logo.svg'
import twitter from '../img/social/twitter.svg'

const Footer = ({ title }) => {
  return (
    <footer className="footer has-background-white">
      <div className="content has-text-centered">{title}</div>
      <div className="content has-text-centered">
        <div className="container">
          <div style={{ maxWidth: '100vw' }} className="columns">
            <div className="column is-4">
              <section className="menu">
                <ul className="menu-list">
                  <li>
                    <Link to="/" className="navbar-item">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link className="navbar-item" to="/about">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link className="navbar-item" to="/support">
                      Support
                    </Link>
                  </li>
                  <li>
                    <Link className="navbar-item" to="/complaints">
                      Complaints
                    </Link>
                  </li>
                </ul>
              </section>
            </div>
            <div className="column is-4">
              <section>
                <ul className="menu-list">
                  <li>
                    <a className="navbar-item" href="https://thebiobreak.com">
                      TheBioBreak
                    </a>
                  </li>
                  <li>
                    <a className="navbar-item" href="https://thedevbranch.com">
                      TheDevBranch
                    </a>
                  </li>
                  <li>
                    <a className="navbar-item" href="https://petzebel.com">
                      Petzebel
                    </a>
                  </li>
                </ul>
              </section>
            </div>
            <div className="column is-4 social">
              <a title="twitter" href="https://twitter.com/ParodyCineUni">
                <img
                  className="fas fa-lg"
                  src={twitter}
                  alt="Twitter"
                  style={{ width: '1em', height: '1em' }}
                />
              </a>
              <a title="tiktok" href="https://www.tiktok.com/@parodycinematicuniverse">
                <img
                  src={tiktok}
                  alt="Tiktok"
                  style={{ width: '1em', height: '1em' }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <p className="has-text-centered">
        Notice how your adblock isn't going off? How there's no trackers or
        cookies? How there's no stupid popups asking to accept handing all of
        your data over? Why? Because Parody Cinematic Universe is incredible
      </p>
    </footer>
  )
}

export default Footer
